export default {
      id: "i-close-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "img/sprite.svg#i-close",
      toString: function () {
        return this.url;
      }
    }